import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../../caremap/CareMapState';
import { AddNoteButton } from './AddNoteButton';
import { AddNoteWithQueryParamDrawer } from './AddNoteWithQueryParamDrawer';

export const QuickAddNote: React.FC<{ useIcon?: boolean }> = ({ useIcon }) => {
    const addNoteDrawer = useInstance(AddNoteWithQueryParamDrawer);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const canAdd = careMapState.hasPermissionTo('post-note');

    return canAdd && (
        <AddNoteButton
            useIcon={useIcon}
            canAdd={canAdd}
            onClick={() => addNoteDrawer.open()}
        />
    );
};
